import { h } from 'preact'
import { Link } from 'preact-router/match'
import { connect } from 'app/store'
import icon from '../assets/icon.svg'

const Logo = () => (
  <Link class="ml-0 mr-4 text-dark no-underline" href="/">
    <img src={icon} class="img-fluid" style="width: 60px" alt="Manter Logo" />{' '}
    <span class="d-none d-sm-none d-md-inline d-lg-inline d-xl-inline mr-2 brand">Manter</span>
  </Link>
)

const PublicNavbar = () => (
  <nav class="p-3 mx-2 navbar navbar-light bg-white">
    <Logo />
    <div class="ml-auto">
      {/* <Link class="text-dark ml-4" href="/features">
        Features
      </Link>
      <Link class="text-dark ml-4" href="/pricing">
        Pricing
      </Link> */}
      <Link class="text-dark ml-4" href="/join">
        Sign Up
      </Link>
      <Link class="text-dark ml-4 font-weight-bold" href="/login">
        Log In
      </Link>
    </div>
  </nav>
)

const PrivateNavbar = () => (
  <nav class="p-3 mx-2 navbar navbar-light bg-white">
    <Logo />
    <div class="ml-auto">
      {/* <Link class="text-dark" href="/search">
        Search
      </Link> */}
      <Link class="text-dark ml-4" href="/tags">
        Tags
      </Link>
      <Link class="text-dark ml-4" href="/settings">
        Settings
      </Link>
    </div>
  </nav>
)

export default connect(
  'auth',
  ({ auth }) => (auth && auth.accessToken ? <PrivateNavbar /> : <PublicNavbar />),
)



// WEBPACK FOOTER //
// ./components/Header.js